import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AlertaService } from "../../services/alerta.service";
import { ParameterGroupService } from "../../services/parameters.service";
import { findParameterGroupAct, loadParameterGroupByIdAct } from "./parameters.actions";
import { catchError, exhaustMap, map, of } from "rxjs";

@Injectable()
export class ParameterGroupEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private parameterGroupService = inject(ParameterGroupService);
    private alerta = inject(AlertaService);

    findParameterGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findParameterGroupAct),
            exhaustMap(action => this.parameterGroupService.findParameterGroupById(action.id)
        .pipe(
            map(parameterGroup => loadParameterGroupByIdAct({ parameterGroup })),
            catchError(error => of(error))
        ))
        )
    );

}